try {
  require('@google/model-viewer');
} catch (e) {
  console.warn(e);
}
